module.exports = __webpack_public_path__ + "img/vaadin_user-card.1d8bdd26.svg";